var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"rsgradient pb-3 pb-1 pt-3 pt-md-5",attrs:{"type":""}}),_c('b-card',{staticStyle:{"margin":"20px"}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_vm._v("Mapa de comercios")]),_c('b-card-body',[_c('CommerceMap')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }